// extracted by mini-css-extract-plugin
export default {"wrapper":"RecoveryPasswordRequest_wrapper__GhT-t","input":"RecoveryPasswordRequest_input__fyux5","button":"RecoveryPasswordRequest_button__03qlG"};